import React from 'react';
import {useTranslation} from 'react-i18next';
import Checkbox from '../../../../../../component/checkbox/Checkbox';
import Btn from '../../../../../../component/button/btn/Btn';
import * as css from './FooterComponent.css';

interface FooterComponentProps {
    allActiveSelected: boolean;
    onSelectAllActive: (isSelected: boolean) => void;
    onClose: () => void;
    onSave: () => void;
}

function FooterComponent({allActiveSelected, onSelectAllActive, onClose, onSave}: FooterComponentProps) {
    const {t} = useTranslation('subscriptions');

    return (
        <css.footer>
            <css.footerCheckbox>
                <Checkbox 
                    selected={allActiveSelected}
                    onClick={onSelectAllActive}
                    classes={'classicCheckbox'}
                    color="primary"
                />
                {t('selectAllActiveEvents')}
            </css.footerCheckbox>
            <css.footerButtons>
                <Btn 
                    className="white"
                    onClick={onClose}
                >
                    {t('cancel')}
                </Btn>
                <Btn 
                    className="primary"
                    onClick={onSave}
                >
                    {t('saveChanges')}
                </Btn>
            </css.footerButtons>
        </css.footer>
    );
}

export default FooterComponent;
